import { ListOffer } from 'dealer-types'
import React, { useRef, useEffect, useState } from 'react'
import View from '../atoms/View'
import BrowseItem, { BROWSE_ITEM_MAX_WIDTH } from './BrowseItem'
import BrowseItemPlaceholder from './BrowseItemPlaceholder'

interface Props {
  estibrand: 'estimoto' | 'esticampo' | 'estiagro'
  offers: ListOffer[]
}

const HomePageAds = ({ estibrand, offers }: Props): JSX.Element => {
  const [itemsPerRowBase, setItemsPerRowBase] = useState(0)
  const ref = useRef<HTMLDivElement>(null)
  const boxStyles = {
    estimoto: 'from-motoOrange to-[#d78c04]',
    esticampo: 'from-campoBlue to-[#199dc9]',
    estiagro: 'from-agroGreen to-[#a5b10b]'
  }
  const gradient = boxStyles[estibrand]

  useEffect(() => {
    setItemsPerRowBase(Math.ceil((ref.current?.clientWidth ?? 1) / BROWSE_ITEM_MAX_WIDTH))
  }, [ref])

  return (
    <div className="w-full bg-motoOrange rounded-b-4 rounded-r-4" ref={ref}>
      {offers.length === 0 || typeof ref.current?.clientWidth === 'undefined' ? (
        <HomePageAdsOffersPlaceholder itemsPerRowBase={itemsPerRowBase} gradient={gradient} />
      ) : (
        <HomePageAdsOffers
          maxWidth={ref.current?.clientWidth}
          offers={offers}
          gradient={gradient}
          itemsPerRowBase={itemsPerRowBase}
        />
      )}
    </div>
  )
}

export default HomePageAds

interface HomePageAdsOffersProps {
  offers: ListOffer[]
  gradient: string
  itemsPerRowBase: number
  maxWidth: number | undefined
}

const HomePageAdsOffers = ({ offers, gradient, itemsPerRowBase, maxWidth }: HomePageAdsOffersProps): JSX.Element => {
  return (
    <View className="rounded-b-4 rounded-r-4">
      <View
        style={{ maxWidth: `${maxWidth ?? 'unset'}px` }}
        className={`flex justify-between p-4 gap-4 bg-gradient-to-r ${gradient} rounded-4`}>
        {offers.map((offer, index) => {
          if (index > itemsPerRowBase - 1) {
            return null
          }
          return (
            <div style={{ width: `${100 / itemsPerRowBase}%` }} className="flex-1" key={offer.id}>
              <BrowseItem
                label1={offer.label1}
                label2={offer.label2}
                offerId={offer.id}
                score={offer.score}
                yourHighestBet={offer.current_dealer_highest_bet}
                highestBet={offer.highest_bet}
                isLiked={offer.is_liked}
                contractStatus={offer.contract_status}
                photo={offer.photo}
                variant="home"
                zipCode=""
                countryCode=""
              />
            </div>
          )
        })}
      </View>
    </View>
  )
}

const HomePageAdsOffersPlaceholder = ({
  gradient,
  itemsPerRowBase
}: {
  gradient: string
  itemsPerRowBase: number
}): JSX.Element => {
  return (
    <View className="rounded-b-4 rounded-r-4">
      <View className={`flex justify-between p-4 gap-4 bg-gradient-to-b ${gradient} rounded-4`}>
        {Array.from({ length: itemsPerRowBase }).map((_, index) => (
          <div className="w-full" key={index}>
            <BrowseItemPlaceholder />
          </div>
        ))}
      </View>
    </View>
  )
}
